import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DmSelectLivesComponent } from './dm-select-lives.component';
import { PaymentSipModule } from '../payment-sip/payment-sip.module';
import { InViewportModule } from 'ng-in-viewport';



@NgModule({
  declarations: [
    DmSelectLivesComponent
  ],
  exports: [
    DmSelectLivesComponent
  ],
  imports: [
    CommonModule,
    PaymentSipModule
  ]
})
export class DmSelectLivesModule { }
